module.exports = __webpack_public_path__ + "static/media/owen-lars.afc5d2f1.jpg";